import Constants from 'expo-constants';

const extra = Constants.expoConfig?.extra;
const expoConfig = Constants.expoConfig!;

export { extra, expoConfig };
